<template>
  <div class="card">
    <div class="card-header text-white bg-dark">
      <h5 class="card-title">{{ position.name }}</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-6 text-center"><img :src="position.img"/></div>
        <div class="col-6" v-html="position.description"></div>
      </div>
    </div>
    <div v-if="position.classification != null" class="card-footer text-center">
      <span>{{ position.classification }}</span>
    </div>
  </div>
</template>

<script>
    export default {
      name: "app-positions-card",
      props: {
        position: { type: Object, requite: true }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-positions-card.vue